<tr class="deltaker e2e-deltaker aksjeeier">
  <td class="valgt">
    <mat-checkbox [checked]="true" class="e2e-deltar" [disabled]="true"/>
  </td>
  <td>
    @if (!erInvitasjon()) {
      <avatar stil="liten" [medlem]="somDeltaker().value.medlem!" [skjulTooltip]="true"/>
    }
  </td>
  <td class="navn e2e-navn">
    <div>{{ representantensNavn() }}</div>
    <div>
      <span class="representerer-tittel">{{ 'Representerer aksjeeier'|translate }}</span>
      <ul>
        @for (aksjeeier of aksjeeiere(); track aksjeeier.id) {
          <li>{{ aksjeeier.navn }}</li>
        }
      </ul>
    </div>
  </td>
  <td class="rolle">{{ aktiveMedlemsroller() }}</td>
  @if (skalSignereValgSynlig()) {
    <td class="skal-signere">
      <mat-slide-toggle [formControl]="skjema().controls.skalSignere" (click)="$event.stopPropagation()" class="e2e-skalsignere"/>
    </td>
  }
</tr>
